/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLiffMemoryUploadVideoRequest
 */
export interface PostLiffMemoryUploadVideoRequest {
    /**
     * 
     * @type {string}
     * @memberof PostLiffMemoryUploadVideoRequest
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof PostLiffMemoryUploadVideoRequest
     */
    memoryId: string;
    /**
     * 
     * @type {string}
     * @memberof PostLiffMemoryUploadVideoRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the PostLiffMemoryUploadVideoRequest interface.
 */
export function instanceOfPostLiffMemoryUploadVideoRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "memoryId" in value;

    return isInstance;
}

export function PostLiffMemoryUploadVideoRequestFromJSON(json: any): PostLiffMemoryUploadVideoRequest {
    return PostLiffMemoryUploadVideoRequestFromJSONTyped(json, false);
}

export function PostLiffMemoryUploadVideoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLiffMemoryUploadVideoRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'memoryId': json['memoryId'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function PostLiffMemoryUploadVideoRequestToJSON(value?: PostLiffMemoryUploadVideoRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': value.fileName,
        'memoryId': value.memoryId,
        'comment': value.comment,
    };
}

